import _asyncToGenerator from "/neworiental/jenkins/workspace/seal-remixed-troy-student-web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.number.parse-int.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getSubjectList as _getSubjectList } from '@/api/modules/study.js';
export default {
  name: 'Subject',
  props: {
    subjectCode: {
      // 如果传入科目，就用传入的
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      active: '',
      subjects: [],
      edu: JSON.parse(localStorage.getItem('userInfo')).edu || 3
    };
  },
  watch: {
    subjectCode: function subjectCode(val) {
      this.active = val;
    }
  },
  created: function created() {
    this.init();
  },
  methods: {
    init: function init() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.getSubjectList();

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    getSubjectList: function getSubjectList() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var _data$;

        var _yield$_getSubjectLis, status, data;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _getSubjectList({
                  edu: _this2.edu,
                  needAll: false // 改为false

                });

              case 2:
                _yield$_getSubjectLis = _context2.sent;
                status = _yield$_getSubjectLis.status;
                data = _yield$_getSubjectLis.data;

                if (!(status !== 1)) {
                  _context2.next = 7;
                  break;
                }

                return _context2.abrupt("return");

              case 7:
                if (!(!data || data.length === 0)) {
                  _context2.next = 10;
                  break;
                }

                _this2.$router.push({
                  path: '/active'
                });

                return _context2.abrupt("return");

              case 10:
                _this2.subjects = data;
                _this2.active = _this2.subjectCode ? Number.parseInt(_this2.subjectCode) : (_data$ = data[0]) === null || _data$ === void 0 ? void 0 : _data$.code;

              case 12:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    subjectChange: function subjectChange(subject) {
      var current = this.subjects.find(function (item) {
        return subject === item.code;
      });
      this.$emit('switchSubject', subject, current);
    }
  }
};